(() => {
  const providers = {
    SCALAPAY: {
      name: 'Scalapay', offer: 'FINO A 36 RATE', accent: '#b9ff00',
      lead: 'La prima rata è prevista tra 30 giorni secondo le condizioni mostrate al checkout.',
      detail: 'Inserisci dati personali corretti e usa un metodo di pagamento supportato. Disponibilità e piano effettivo sono valutati da Scalapay quando scegli il pagamento.',
      url: 'https://help.scalapay.com/it/articles/217285-come-creare-un-account-scalapay'
    },
    KLARNA: {
      name: 'Klarna', offer: 'FINO A 12 RATE', accent: '#8b61ff',
      lead: 'Le opzioni disponibili dipendono dall’acquisto e vengono mostrate al checkout.',
      detail: 'I dati personali e il metodo di pagamento devono essere aggiornati. Klarna determina direttamente la disponibilità e l’eventuale verifica di idoneità.',
      url: 'https://www.klarna.com/it/servizio-clienti/'
    },
    ALMA: {
      name: 'Alma', offer: 'FINO A 12 RATE', accent: '#b9ff00',
      lead: 'Il piano viene mostrato prima della conferma del pagamento.',
      detail: 'Per i piani più lunghi Alma può richiedere un documento di identità e una verifica della capacità di rimborso. Servono dati personali e un metodo di pagamento validi.',
      url: 'https://almapay.com/it-IT/prodotti/il-pagamento-in-10-o-12-rate'
    },
    SEQURA: {
      name: 'SeQura', offer: 'FINO A 12 RATE', accent: '#55cce7',
      lead: 'La disponibilità e gli importi sono confermati durante il pagamento.',
      detail: 'SeQura o il partner finanziario valuta la richiesta. Controlla nel riepilogo la prima rata, le scadenze successive e le condizioni applicabili.',
      url: 'https://www.sequra.com/it/faq'
    }
  };

  let dialog;
  let activeTrigger;

  function buildDialog() {
    dialog = document.createElement('dialog');
    dialog.className = 'mg-payment-dialog';
    dialog.setAttribute('aria-labelledby', 'mg-payment-dialog-title');
    dialog.innerHTML = `
      <div class="mg-payment-dialog__body">
        <button class="mg-payment-dialog__close" type="button" aria-label="Chiudi i dettagli dei pagamenti">×</button>
        <p class="mg-payment-dialog__kicker">PAGAMENTI FLESSIBILI</p>
        <h2 id="mg-payment-dialog-title"></h2>
        <strong class="mg-payment-dialog__offer"></strong>
        <p class="mg-payment-dialog__lead"></p>
        <div class="mg-payment-dialog__divider"></div>
        <h3>COME FUNZIONA</h3>
        <p class="mg-payment-dialog__detail"></p>
        <div class="mg-payment-dialog__note">
          <b>PRIMA DI CONFERMARE</b>
          <p>Controlla importi, scadenze, eventuali costi e requisiti nel riepilogo del provider. La disponibilità delle rate e l’approvazione non sono garantite da Minimal Gamers.</p>
        </div>
        <a class="mg-payment-dialog__link" target="_blank" rel="noopener noreferrer">LEGGI I DETTAGLI UFFICIALI <span aria-hidden="true">↗</span></a>
      </div>`;
    document.body.appendChild(dialog);
    dialog.querySelector('.mg-payment-dialog__close').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => {
      document.body.classList.remove('mg-payment-dialog-open');
      if (activeTrigger?.isConnected) activeTrigger.focus();
    });
    return dialog;
  }

  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-mg-payment-provider]');
    if (!trigger) return;
    const data = providers[trigger.dataset.mgPaymentProvider];
    if (!data) return;
    activeTrigger = trigger;
    const panel = dialog || buildDialog();
    panel.style.setProperty('--mg-provider-color', data.accent);
    panel.querySelector('h2').textContent = data.name;
    panel.querySelector('.mg-payment-dialog__offer').textContent = data.offer;
    panel.querySelector('.mg-payment-dialog__lead').textContent = data.lead;
    panel.querySelector('.mg-payment-dialog__detail').textContent = data.detail;
    panel.querySelector('.mg-payment-dialog__link').href = data.url;
    document.body.classList.add('mg-payment-dialog-open');
    if (!panel.open) panel.showModal();
    panel.querySelector('.mg-payment-dialog__close').focus();
  });
})();
